import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-715160e4")

_pushScopeId("data-v-715160e4")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" カルテ閲覧・編集 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, "カルテを閲覧または作成する患者を検索する方法を選んでください。", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("予約日から")
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("患者を検索 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("患者一覧")
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("から検索 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("問診回答")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("着信一覧")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_badge_frame = _resolveComponent("badge-frame")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ]),
          _createVNode("div", null, _toDisplayString(_ctx.today), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode("div", {
        class: ["button-row", _ctx.$mq]
      }, [
        _createVNode(_component_normal_button, {
          class: "dashboard-button",
          state: "warning",
          large: true,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/karte_by_appointment?y=${_ctx.thisYear}&m=${_ctx.thisMonth}`)))
        }, {
          default: _withId(() => [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_normal_button, {
          class: "dashboard-button",
          state: "normal",
          large: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/karte_by_patient_list`)))
        }, {
          default: _withId(() => [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        })
      ], 2),
      _createVNode("div", {
        class: ["button-row", _ctx.$mq]
      }, [
        _createVNode(_component_badge_frame, { count: 0 }, {
          default: _withId(() => [
            _createVNode(_component_normal_button, {
              class: "dashboard-button",
              state: "normal",
              large: true,
              disabled: true,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/patient_answer`)))
            }, {
              default: _withId(() => [
                _hoisted_9,
                _hoisted_10,
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 2)
    ]),
    _: 1
  }))
})